

















































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public followShow = false;
  public animeClass = false;
  public showToTop = false;
  public scrollTop: any = 0;
  public mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  }
  public destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  public toAdd() {
    if ((document as any).getElementById("contactUs")) {
      (document as any)
        .getElementById("contactUs")
        .scrollIntoView({ behavior: "smooth" });
    } else {
      window.open(
        "http://wpa.qq.com/msgrd?v=3&uin=5285770&site=qq&menu=yes",
        "_blank"
      );
    }
  }
  public followEnter() {
    this.followShow = true;
  }
  public followLeave() {
    this.followShow = false;
  }
  public handleScroll() {
    const that = this;
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    that.scrollTop = scrollTop;
    if (that.scrollTop > 300) {
      that.showToTop = true;
    } else {
      that.showToTop = false;
    }
  }
  public toTop() {
    const that = this;
    const timer = setInterval(() => {
      const ispeed = Math.floor(-that.scrollTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop =
        that.scrollTop + ispeed;
      if (document.documentElement.scrollTop < 0) {
        this.scrollTop = 0;
      }
      if (that.scrollTop === 0) {
        clearInterval(timer);
      }
    }, 16);
  }
}
